"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitCult = void 0;
require('slick-carousel');
function InitCult() {
    const toggleProductInfo = () => {
        jQuery('#toggle-product-info').click(function () {
            jQuery('#product-info').toggleClass('open');
            jQuery('#toggle-product-info').toggleClass('open');
        });
    };
    const toggleNavi = () => {
        jQuery('#navi-toggle').click(function () {
            jQuery('#navigation').toggleClass('open');
            jQuery('#navi-toggle').toggleClass('close');
            jQuery('.header-logo').toggleClass('navi-open');
        });
    };
    const formScripts = () => {
        jQuery('.FormSubmitButton').on("click", function () {
            console.log('submitted');
            setTimeout(() => {
                if (jQuery('.Form__Element.ValidationFail').length === 0) {
                    jQuery('body').addClass('form-submitted');
                    jQuery(window).scrollTop(0);
                }
            }, 500);
        });
        // Form Container Block textarea script fix
        jQuery('.FormTextbox--Textarea .FormTextbox__Input').on('focus', function () {
            jQuery(this).attr('placeholder', '');
        });
        jQuery('.FormTextbox--Textarea .FormTextbox__Input').on('blur', function () {
            const placeholderValue = jQuery(this).attr('data-f-label');
            jQuery(this).attr('placeholder', placeholderValue);
        });
    };
    $(document).ready(function () {
        toggleProductInfo();
        toggleNavi();
        formScripts();
        if (jQuery('.product-listing-block.product-details').length) {
            jQuery('body').addClass('product-details');
        }
        // YouTube video autoplay after preview play button click
        jQuery('.play-video').click(function () {
            const iFrm = jQuery(this).parents('.o-video-container').children('iframe');
            console.log('iFrm', iFrm);
            if (iFrm.length) {
                const win = window.$(iFrm)[0];
                win.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            }
        });
    });
}
exports.InitCult = InitCult;
